import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import CardExternalLink from "./CardExternalLink"

const ProjectCard = ({
  image,
  title,
  description,
  technologies,
  url,
  year,
}) => (
  <article className="project-entry" data-content-type="project">
    <div className="project-entry__image" data-field="image">
      {image && (
        <GatsbyImage
          image={image}
          alt={title}
          className="project-entry__gatsby-image"
          imgStyle={{ objectFit: "contain" }}
        />
      )}
    </div>
    <div className="project-entry__content">
      <span className="project-entry__year" data-field="year">
        {year}
      </span>
      <h2 data-field="title">{title}</h2>
      <p data-field="description">{description}</p>
      <div className="project-entry__bottom">
        <div className="project-entry__technologies" data-field="technologies">
          {technologies.map(technology => (
            <span key={technology}>{technology}</span>
          ))}
        </div>
        {url ? (
          <div data-field="primary-link">
            <CardExternalLink url={url} label="Open" />
          </div>
        ) : (
          <span className="project-entry__internal">Internal</span>
        )}
      </div>
    </div>
  </article>
)

export default ProjectCard
